module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/bottommenu/integral_on.png";